import {nanoid} from "nanoid";
import {Auth, FirebaseUser, IdTokenResult, OnAuthChangedCallBack} from "../components/auth/types";
import {wait} from "./test-util";
import {UserInfo} from "@firebase/auth";

export class MockAuth implements Auth {
  private cb: OnAuthChangedCallBack | undefined;
  private currentUser: FirebaseUser | null = null
  onIdTokenChanged(cb: OnAuthChangedCallBack): () => void {
    this.cb = cb;
    wait(1).then(() => this.runCallBack());
    return () => {
      this.cb = undefined;
    };
  }

  async signIn(firebaseUser: FirebaseUser = mockFirebaseUser()) {
    this.currentUser = firebaseUser
    await this.runCallBack();
    return firebaseUser;
  }
  async signOut() {
    this.currentUser = null;
    await this.runCallBack();
  }
  getCurrentUser(): FirebaseUser | null {
    return this.currentUser;
  }
  private async runCallBack() {
    await wait(10);
    this.cb?.(this.currentUser);
  }
}

export type UserOpts = {
  email?: string
  displayName?: string
  uid?: string
  idToken?: string
  provider?: string
  photoURL?: string
  emailVerified?: boolean
  claims?: {[key: string]: string}
}

export const mockFirebaseUser = (opts: UserOpts = {}): FirebaseUser => {
  const uid = opts.uid || nanoid();
  const idToken = opts.idToken || nanoid();
  const provider = opts.provider || "password";
  const providerData = [userInfoFromProvider(provider)];
  const claims = opts.claims || {};
  const emailVerified = opts.emailVerified || false;
  return {
    uid,
    providerId: "firebase",
    displayName: opts.displayName || null,
    email: opts.email || generateEmail(),
    photoURL: opts.photoURL || null,
    emailVerified,
    providerData,
    getIdToken(forceRefresh?: boolean): Promise<string> {
      return Promise.resolve(idToken);
    },
    getIdTokenResult(forceRefresh? : boolean): Promise<IdTokenResult> {
      const tokenResult: IdTokenResult = {
        claims: claims,
        token: idToken
      };
      return Promise.resolve(tokenResult)
    }
  }
}

export const userInfoFromProvider = (providerId: string, uid: string = nanoid()): UserInfo => ({
  uid,
  providerId: providerId,
  displayName: null,
  email: null,
  phoneNumber: null,
  photoURL: null,
});

const generateEmail = () => `${nanoid(5)}@wakelet.com`